// Old content was stored with escape(), which decodeURIComponent cannot read.
const LEGACY_ESCAPE = /%u([0-9A-Fa-f]{4})/g;

// Not re-encoded: emoji arrive as surrogate pairs, and encodeURIComponent
// throws on the lone surrogate half.
const decodeLegacyEscapes = (value) =>
    value.replace(LEGACY_ESCAPE, (match, hex) => String.fromCharCode(parseInt(hex, 16)));

export const safeDecodeContent = (value) => {
    if (typeof value !== 'string' || value === '') return value;

    try {
        return decodeURIComponent(decodeLegacyEscapes(value));
    } catch (e) {
        console.warn('Malformed content, skipping decode:', value, e);
        return value;
    }
};
